<template>
  <div ref="chart" class="chart-component">
    <div class="chart" v-if="empty">
      <v-chart ref="echart" :option="options" theme="theme" autoresize @datazoom="datazoom" @click="clickChart" @mouseover="mouseOverChart" @mouseout="mouseOutChart"></v-chart>
    </div>
    <empty v-else></empty>
  </div>
</template>

<script>
import empty from '@/components/empty.vue'
import ECharts from 'vue-echarts'
import * as echarts from 'echarts'
import theme from '@/echarts/theme.json'
import china from '@/echarts/china.json'
import world from '@/echarts/world.json'
echarts.registerMap('world', world)
echarts.registerMap('china', china)
echarts.registerTheme('theme', theme)
import 'echarts-wordcloud'
export default {
  name: 'echart',
  components: {
    empty,
    'v-chart': ECharts,
  },
  props: {
    options: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      width: 0,
      height: 0
    }
  },
  mounted() {
  },
  computed: {
    empty() {
      return this.options.series && this.options.series.length >0 && this.options.series[0].data.length >0
    }
  },
  methods: {
    datazoom(val) {
      this.$emit('change-zoom', val)
    },
    clickChart(val) {
      this.$emit('click-chart', val)
    },
    mouseOverChart(val) {
      this.$emit('mouseover-chart', val)
    },
    mouseOutChart(val) {
      this.$emit('mouseout-chart', val)
    },
    getEchartInstance() {
      const chartElement = this.$refs.echart.$el;
      const echartInstance = echarts.getInstanceByDom(chartElement);
      return echartInstance
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-component {
  width: 100%;
  .chart {
    width: 100%;
    height: 100%;
    .back {
    }
  }
  .echarts {
    width: 100%;
    height: 100%;
    div {
      height: 100%;
    }
  }
}
</style>
